// IE 2026 09 23 / ODOO-… (замечание Игоря: «в режиме "Full screen" не видны формы-меню»): корень для оверлеев — телепортов панелей функций
// (MenuPanel), формы ячейки (Dropdown), окон легенд; appendChild подсказок, меню грида, «продолжения» обрезанного текста.
// Браузер рисует только поддерево полноэкранного элемента (Fullscreen API, top layer): всё, что лежит в body ВНЕ него, невидимо и не ловит мышь.
// Команда Full screen окна теперь переводит в полноэкран весь документ (html, mainStore onFullscreen__Click) — корень оверлеев остаётся body;
// в полноэкране ВИДЖЕТА (Shift Alt F, элемент #WIDGET<id>) корень — сам виджет. Реактивность: чтение идёт через reactive-счётчик, который
// растёт на fullscreenchange, — computed / render, вызвавшие fullscreenEl() / overlayRoot() / overlayPortal(), перечитываются при смене полноэкрана.
import { reactive } from 'vue'

const state = reactive({ epoch: 0 })
let listening = false
function listen() {
    if (listening || typeof document === 'undefined') return
    listening = true
    const bump = () => { state.epoch++ }
    document.addEventListener('fullscreenchange', bump)
    document.addEventListener('webkitfullscreenchange', bump)
}

// полноэкранный элемент, если это НЕ корень документа (полноэкран виджета); иначе null
export function fullscreenEl() {
    listen()
    void state.epoch
    if (typeof document === 'undefined') return null
    const fs = document.fullscreenElement || document.webkitFullscreenElement || null
    return fs && fs !== document.documentElement ? fs : null
}

// корень оверлеев: полноэкранный виджет либо body
export function overlayRoot() {
    return fullscreenEl() || document.body
}

// предпочитаемый портал (контейнер страницы у окон легенд), если он внутри полноэкранного поддерева; иначе полноэкранный виджет;
// без полноэкрана (или полноэкран — весь документ) — сам портал либо body
export function overlayPortal(preferred) {
    const fs = fullscreenEl()
    if (!fs) return preferred || document.body
    return (preferred && fs.contains(preferred)) ? preferred : fs
}
